import { gql } from '@apollo/client';

export const RECAPTCHA_QUERIES = gql`
  query RecaptchaVerify($listingId: String!, $token: String!) {
    recaptchaVerify(listingId: $listingId, token: $token) {
      valid
      email
      phone
    }
  }
`;
